import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { useMemo } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * Header
 */

type Props = {
  status: number;
  centroCustos: number[] | null;
  centroCustoDropdown: CentroCustoDropDown[];
  onStatusChange: (value?: number) => void;
  onCentroCustoChange: (value: number[]) => void;
  onClearFilters: () => void;
};

export const Header = ({
  status,
  centroCustos,
  centroCustoDropdown,
  onStatusChange,
  onCentroCustoChange,
  onClearFilters,
}: Props) => {
  const statusOptions = useMemo(() => {
    return [
      {
        id: 2,
        label: 'Todos',
      },
      {
        id: 0,
        label: 'Em Andamento',
      },
      {
        id: 1,
        label: 'Finalizados',
      },
    ];
  }, [
  ]);

  const selectedCentroCustos = useMemo(() => {
    if (!centroCustos) return null;
    return centroCustoDropdown.filter(x => centroCustos.includes(x.id));
  }, [
    centroCustos,
    centroCustoDropdown,
  ]);


  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-2">
          <div className="w-full grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <DefaultSelectInput
                name='status'
                label='Status'
                showSelectionLabel={false}
                options={statusOptions}
                value={status}
                onChangeValue={e => onStatusChange(Number(e))}
              />
            </div>

            <DefaultMultiAutocomplete
              label='Centro de Custo'
              options={centroCustoDropdown}
              getOptionKey={x => x.id}
              getOptionLabel={x => x.title}
              value={selectedCentroCustos}
              onChange={x => onCentroCustoChange(x !== null ? x.map(i => i.id) : [])}
            />


          </div>

          <div className="w-full flex flex-col items-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}